class HeaderMenu extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    document.addEventListener('drawerOpen', e => {
      if (e.detail.key === 'desktop') {
        if (this?.externalEls?.scroller) {
          this.externalEls.scroller.element.scrollTop = 0
        }

        // If the parent drawer has an invisible class, we remove it
        this.closest('.drw-Drawer-invisible')?.classList.remove(
          'drw-Drawer-invisible',
        )
      }
    })
  }
}

if (!customElements.get('header-menu')) {
  customElements.define('header-menu', HeaderMenu)
}
